import * as Inflected from 'inflected';

/**
 * Returns the singular or plural version of a string based on count.
 */
export function pluralize(
  count: number,
  text: string,
  locale?: string
): string {
  return count === 1 ? text : Inflected.pluralize(text, locale);
}

Inflected.inflections('en', inflect => {
  inflect.plural(/^sec\.$/i, 'secs.');
  inflect.plural(/^min\.$/i, 'mins.');
  inflect.plural(/^hr\.$/i, 'hrs.');
});
